import PropTypes from 'prop-types';
import React from 'react';
import { useSectionContext } from '../withSectionContext';
function withSection(WrappedComponent) {
    const WithSection = (props)=>{
        const { section } = useSectionContext() || {};
        return /*#__PURE__*/ React.createElement(WrappedComponent, {
            section: section,
            ...props
        });
    };
    WithSection.contextTypes = {
        formName: PropTypes.string,
        disabled: PropTypes.bool
    };
    return WithSection;
}
export default withSection;
